import React, { useState, useEffect } from 'react';
import { Spinner } from 'reactstrap';

import FormatDate from 'lib/FormatDate';

import { Show, Objects, Actions } from '../../services/AccessControl';

import { OrganigrammeApi } from '../../api/OrganigrammeApi';

import CreateModal from 'components/Orga/CreateModal';
import UpdateModal from 'components/Orga/UpdateModal';
import OrganigrammeCAPDF from '../pdfs/Organigrammes/OrganigrammeCAPDF';

export default ({ id }) => {

    const [organigramme, setOrganigramme] = useState();
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = _ => {
        OrganigrammeApi
            .get(id)
            .then(res => setOrganigramme(res))
            .finally(_=> setIsLoading(false))
    }

    const reload = _ => fetchData();

    useEffect(fetchData, []);

    const handleRemove = id => {
        OrganigrammeApi
            .delete(id)
            .then(reload)
    }

    if (isLoading)
        return <Spinner />;

    return (<>
        <div className="row">
            <div className="col">
                <h3 className="h3 mb-4">Organigramme</h3>
            </div>
            <div className="col-auto m-0">
                <Show object={Objects.Organigramme} action={Actions.Create} >
                    <CreateModal
                        id={id}
                        reload={reload}
                    />
                </Show>
            </div>
            <div className="col-auto m-0">
                <OrganigrammeCAPDF id={id}/>
            </div>
        </div>


        <div className="card">
            <div className="table-responsive-xl">
                <table className="table table-hover mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col" className="text-dark">Poste</th>
                            <th scope="col" className="text-dark">Nom</th>
                            <th scope="col" className="text-dark">Prénom</th>
                            <th scope="col" className="text-dark">Matricule</th>
                            <th scope="col" className="text-dark">Date Début</th>
                            <th scope="col" className="text-dark">Date Fin</th>
                            <th scope="col" className="text-dark">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {organigramme?.map((e, i) => <tr key={i}>
                            <td>{e?.post}</td>
                            <td>{e?.lastName}</td>
                            <td>{e?.firstName}</td>
                            <td>{e?.matricule}</td>
                            <td>{e?.startDate ? FormatDate(e.startDate) : "/"}</td>
                            <td>{e.endDate ? FormatDate(e.endDate) : "/"}</td>
                            <td>
                                <Show object={Objects.Organigramme} action={Actions.Create} >
                                    <UpdateModal
                                        id={e.id}
                                        reload={reload}
                                        initStartDate={e?.startDate}
                                        initEndDate={e?.endDate}
                                    />
                                </Show>
                                <Show object={Objects.Organigramme} action={Actions.Delete} >
                                    <button className="btn btn-danger mr-2" onClick={_ => handleRemove(e.id)}>
                                        <i className="fas fa-trash fa-sm" data-toggle="tooltip" title="Supprimer" />
                                    </button>
                                </Show>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        </div>
    </>);
}
